import React, { useState } from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ReplyIcon from '@mui/icons-material/Reply';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { green, pink } from '@mui/material/colors';
import Box from '@mui/material/Box';
import { Tooltip } from '@mui/material';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import { authUtils } from 'utils/authUtils.js';

export default function CommentComponent(props) {
  const getComment = props.getComment;
  const registerComment = props.registerComment;
  const { boardId, id, kind, comment, isChoose, createdId, parentId } = props.comment;
  const [commentData, setCommentData] = useState('');
  const [showInput, setShowInput] = useState(false);
  const [showReply, setShowReply] = useState(false);
  const auth = useRecoilValue(authAtom);

  const selectComment = async () => {
    console.log(props.comment);
  };

  const openReplyComment = async () => {
    await setCommentData('');
    await setShowReply(true);
  };

  const registerReplyCancel = async () => {
    await setShowReply(false);
  };

  const openModifyComment = async () => {
    await setCommentData(comment);
    await setShowInput(true);
  };

  const modifyCommentCancel = async () => {
    setShowInput(false);
  };

  const modifyComment = async () => {
    await axios
      .patch(`/api/comment/${kind}/${boardId}/${id}`, { commentData })
      .then((response) => {
        alert(response.data.message);
        getComment();
        setShowInput(false);
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const handleChange = (e) => {
    setCommentData(e.target.value);
  };

  const deleteComment = async (data) => {
    await axios
      .delete(`/api/comment/${kind}/${boardId}/${id}`)
      .then((response) => {
        alert(response.data.message);
        getComment();
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const registerReply = async () => {
    let data = { datas: {} };
    data.datas.parentId = id;
    data.datas.comment = commentData;
    registerComment(data)
      .then((response) => {
        alert(response.data.message);
        getComment();
        setCommentData('');
        setShowReply(false);
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  return (
    <>
      <ListItem alignItems="flex-start" sx={{ ml: id === parentId ? 0 : 1 }}>
        {id !== parentId && <SubdirectoryArrowRightIcon />}
        <ListItemText
          primary={
            <>
              {createdId}
              {props.comment.createdAt && (
                <Typography component="span" variant="caption" align="right" color="text.primary" sx={{ ml: 1 }}>
                  ({props.comment.createdAt})
                </Typography>
              )}
            </>
          }
          secondary={
            <>
              {showInput ? (
                <TextField id="comment" variant="outlined" multiline sx={{ minWidth: 350 }} value={commentData || ''} onChange={handleChange} size="small" fullWidth />
              ) : (
                <Typography sx={{ display: 'inline' }} component="span" variant="body2" color="text.primary">
                  {comment}
                </Typography>
              )}
            </>
          }
        />
        <Box>
          {showInput ? (
            <>
              <Tooltip title={'수정 저장'}>
                <IconButton>
                  <CheckIcon sx={{ color: green[500] }} onClick={modifyComment} />
                </IconButton>
              </Tooltip>
              <Tooltip title={'수정 취소'}>
                <IconButton>
                  <CloseIcon sx={{ color: pink[500] }} onClick={modifyCommentCancel} />
                </IconButton>
              </Tooltip>
            </>
          ) : (
            <>
              {auth && id === parentId && (
                <Tooltip title={'댓글'}>
                  <IconButton>
                    <ReplyIcon onClick={openReplyComment} />
                  </IconButton>
                </Tooltip>
              )}
              {false && (
                <Tooltip title={'답변 선정'}>
                  <IconButton>
                    <ThumbUpAltIcon onClick={selectComment} />
                  </IconButton>
                </Tooltip>
              )}
              {auth && (authUtils.useIsAdmin() || auth.userid === createdId) && (
                <Tooltip title={'수정'}>
                  <IconButton>
                    <EditIcon onClick={openModifyComment} />
                  </IconButton>
                </Tooltip>
              )}
              {auth && (authUtils.useIsAdmin() || auth.userid === createdId) && (
                <Tooltip title={'삭제'}>
                  <IconButton>
                    <DeleteIcon onClick={deleteComment} />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}
        </Box>
      </ListItem>
      {showReply && (
        <>
          <SubdirectoryArrowRightIcon sx={{ ml: '3%' }} />
          <TextField id="comment" variant="outlined" multiline sx={{ minWidth: 350, width: '80%' }} value={commentData || ''} onChange={handleChange} size="small" />
          <Tooltip title={'저장'}>
            <IconButton>
              <CheckIcon sx={{ color: green[500] }} onClick={registerReply} />
            </IconButton>
          </Tooltip>
          <Tooltip title={'취소'}>
            <IconButton>
              <CloseIcon sx={{ color: pink[500] }} onClick={registerReplyCancel} />
            </IconButton>
          </Tooltip>
        </>
      )}
      <Divider />
    </>
  );
}
